module.exports = __webpack_public_path__ + "img/SH.2a4045e4.png";